import emailjs from '@emailjs/browser';
import {faChampagneGlasses, faCircle, faPaperPlane, faSpinner, faCircleExclamation} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {motion} from 'framer-motion/dist/framer-motion'
import React, {useRef, useState} from 'react';
import {Trans} from "react-i18next";
import TimePicker from 'react-time-picker';
import 'react-time-picker/dist/TimePicker.css';
import styled from 'styled-components';
import validator from 'validator'
import SectionDetails from './SectionDetails';
import SectionHeader from './SectionHeader';
import 'react-clock/dist/Clock.css';

const Wrapper = styled(motion.div)`
    display: block;
    height: 600px;
    @media (max-width: 800px) {
        margin-top: 0px;
        height: 600px;
    }
`
const StyledSectionDetails = styled(SectionDetails)`
    @media (max-width: 800px) {
        margin-top: 0px;
        height: 30px;
    }
`

const WrapperForm = styled(motion.div)`
    margin-top: 150px;
    margin-bottom: 150px;
    width: 100%;
`
const InformationWrapper = styled(motion.div)`
    display: block;
    height: 600px;
    width: 70%;
    margin-left: 16%;
    @media (max-width: 800px) {
        padding-top: 40px;
        height: 600px;
    }
`

const Form = styled(motion.form)`
    width: 500px;
    text-align: left;
    margin: 0 auto;
    margin-top: 50px;
    @media (max-width: 800px) {
        width: 280px;
    }
`

const StyledInput = styled.input`
    font-family: 'Montserrat';
    width: 99%;
    height: 30px;
    border-radius: 5px;
    font-size: 1.2em;
    margin-bottom: 10px;
`

const StyledTextArea = styled.textarea`
    font-family: 'Montserrat';
    width: 99%;
    height: 120px;
    border-radius: 5px;
    font-size: 1.2em;
    margin-bottom: 10px;
`

const StyledButton = styled.button`
    font-size: 2em;
    background-color: black;
    color: white;
    cursor: pointer;
    width: 50px;
    height: 50px;
    display: inline-block;
    border: none;

    &:hover {
        opacity: .8;
    }
`

const StyledButtonSubmit = styled(StyledButton)`
    margin-left: 450px;
    @media (max-width: 800px) {
        margin-left: 230px;
    }
`

const StyledButtonIcon = styled(FontAwesomeIcon)`
    margin-top: 0px;
`
const Label = styled.label`
    font-family: 'Montserrat';
    display: block;
    font-size: 1em;
    @media (max-width: 800px) {
        font-size: .8em;
    }
`

const Information = styled.div`
    font-family: "Lora";
    font-size: 2em;
    font-style: italic;
    font-weight: 300;
    color: #c1c1c1;
    margin-top: 100px;
    width: 70%;
    display: inline-block;
    @media (max-width: 800px) {
        font-size: 1.2em;
    }
`;

const Icon = styled(FontAwesomeIcon)`
    width: 100%;
    text-align: center;
    display: block;
    font-size: 5em;
    margin-top: 120px;
`

const Card = styled.div`
    width: 30%;
    height: 400px;
    margin-left: 1.2%;
    margin-top: 20px;
    text-align: center;
    margin-top: 120px;
    font-weight: 600px;
    float: left;
    cursor: pointer;

    &:hover {
        opacity: .8;
    }

    @media (max-width: 800px) {
        display: block;
        width: 80%;
        height: 100px;
        margin-left: 10%;
        margin-top: 0px;
        margin-bottom: 80px;
    }
`

const CardHeader = styled.div`
    font-family: 'Montserrat';
    width: 100%;
    text-align: center;
    display: block;
    font-size: 1.3em;
    font-weight: 900;
    margin-top: 50px;
    @media (max-width: 800px) {
        font-size: 1em;
        margin-top: 10px;
    }
`

const CardInfo = styled.div`
    font-family: 'Montserrat';
    width: 100%;
    text-align: center;
    display: block;
    font-size: 1em;
    margin-top: 20px;
    @media (max-width: 800px) {
        font-size: .6em;
        margin-top: 5px;
    }
`


const CardIcon = styled(FontAwesomeIcon)`
    width: 100%;
    text-align: center;
    display: block;
    font-size: 4em;
    margin-top: 50px;
    @media (max-width: 800px) {
        font-size: 2em;
    }
`

const TimeWrapper = styled.div`
    font-family: 'Montserrat';
    background-color: white;
    color: black;
    width: 130px;
    height: 30px;
    border-radius: 5px;
    font-size: 1.2em;
    margin-bottom: 10px;

`

function Reservation({event}) {
    const formToSend = useRef();
    const [form, setForm] = useState("formInfo");
    const [emailType, setEmailType] = useState(event.name);
    const [emailError, setEmailError] = useState(null)
    const [nameError, setNameError] = useState(null)
    const [phoneError, setPhoneError] = useState(null)
    const [dateError, setDateError] = useState(null)
    const [timeError, setTimeError] = useState(null)
    const [guestsError, setGuestsError] = useState(null)
    const [currentDate, setCurrentDate] = useState(event.utfDate.substring(0, 10))
    const [time, onChange] = useState('21:00');

    const returnToInitial = () => {
        setForm("formInfo")
    }

    const sendEmail = (e) => {
        e.preventDefault();

        let isEmailValid = validateEmail(e);
        let isNameValid = validateName(e);
        let isPhoneValid = validatePhone(e);
        let isDateValid = validateDate(e);
        let isTimeValid = validateTime(e);
        let isGuestsValid = validateGuests(e);

        if (isEmailValid && isNameValid && isPhoneValid && isGuestsValid && isDateValid) {
            setForm("formSending")
            emailjs.sendForm('service_t7ophg9', 'template_3yjnjg2', formToSend.current, '3f9_BiSGqWCpaRacc')
                .then((result) => {
                    setForm("formSuccess");
                }, (sendingError) => {
                    console.log(sendingError.text);
                    setForm("formError");
                });
        }

    };

    const validateEmail = () => {
        let email = formToSend.current.email.value
        if (email && validator.isEmail(email)) {
            setEmailError(null)
            return true;
        } else {
            setEmailError(' - Моля, въведете валиден имейл адрес.')
            return false;
        }
    }

    const validateName = () => {
        if (formToSend.current.name.value) {
            setNameError(null)
            return true;
        } else {
            setNameError(' - Полето не може да бъде празно.')
            return false;
        }
    }

    const validatePhone = () => {
        if (formToSend.current.phone.value) {
            setPhoneError(null)
            return true;
        } else {
            setPhoneError(' - Моля въведете валиден телефон.')
            return false;
        }
    }

    const validateDate = () => {
        if (formToSend.current.date.value) {
            const date = formToSend.current.date.value;
            setDateError(null);
            return true;
        } else {
            setDateError(' - Моля изберете дата.')
            return false;
        }
    }

    const validateTime = () => {
        if (formToSend.current.date.value) {
            setTimeError(null)
            return true;
        } else {
            setTimeError(' - Моля изберете час.')
            return false;
        }
    }

    const validateGuests = () => {
        if (formToSend.current.guests.value) {
            setGuestsError(null)
            return true;
        } else {
            setGuestsError(' - Полето не може да бъде празно.')
            return false;
        }
    }

    if (form === "formInfo") {
        return (
            <WrapperForm
                initial={{opacity: 0, x: -200}}
                whileInView={{opacity: 1, x: 0}}
                viewport={{once: true}}>
                <SectionHeader title={<Trans>RESERVE</Trans>}/>
                <Form ref={formToSend}>
                    <Label htmlFor="email">Email * {emailError}</Label>
                    <StyledInput type="email" name="email" id="email"/>
                    <Label htmlFor="name"><Trans>Name</Trans> * {nameError}</Label>
                    <StyledInput type="text" name="name" id="name"/>
                    <Label htmlFor="phone"><Trans>Phone</Trans> * {phoneError}</Label>
                    <StyledInput type="text" name="phone" id="phone"/>
                    <StyledInput type="hidden" name="date" id="date" value={currentDate}/>
                    <Label htmlFor="time"><Trans>Time</Trans> * {timeError}</Label>
                    <TimeWrapper>
                        <TimePicker clearIcon="" name="time" id="time" minTime="19:00" maxTime="23:00"
                                    onChange={onChange} value={time}/>
                    </TimeWrapper>
                    <Label htmlFor="guests"><Trans>Number of guests</Trans> * {guestsError}</Label>
                    <StyledInput min="1" max="500" type="number" name="guests" id="guests"/>
                    <Label htmlFor="message"><Trans>Additional Information</Trans></Label>
                    <StyledTextArea type="textarea" name="message" id="message"/>
                    <StyledInput type="hidden" name="type" id="type" value={emailType}/>
                    <StyledInput type="hidden" name="translated_date" id="translated_date" value={currentDate}/>
                    <br/>
                    <StyledButtonSubmit type="submit" onClick={(e) => sendEmail(e)}><StyledButtonIcon size="lg"
                                                                                                      icon={faPaperPlane}/></StyledButtonSubmit>
                </Form>
            </WrapperForm>
        )
    } else if (form === "formSuccess") {
        return (
            <Wrapper
                initial={{opacity: 0, x: -200}}
                whileInView={{opacity: 1, x: 0}}
                viewport={{once: true}}
                onClick={() => returnToInitial()}>
                <SectionHeader title={<Trans>RESERVE</Trans>}/>
                <InformationWrapper>
                    <Information><Trans>Success Message</Trans></Information>
                    <Icon size="lg" icon={faChampagneGlasses}/>
                </InformationWrapper>
            </Wrapper>
        )
    } else if (form === "formError") {
        return (
            <Wrapper
                initial={{opacity: 0, x: -200}}
                whileInView={{opacity: 1, x: 0}}
                viewport={{once: true}}
                transition={{delay: 0.3, delayChildren: 0.5}}
                onClick={() => returnToInitial()}>
                <SectionHeader title={<Trans>RESERVE</Trans>}/>
                <InformationWrapper>
                    <Information><Trans>Error Message</Trans></Information>
                    <Icon size="lg" icon={faCircleExclamation}/>
                </InformationWrapper>
            </Wrapper>
        )
    } else if (form === "formSending") {
        return (
            <Wrapper
                initial={{opacity: 0, x: -200}}
                whileInView={{opacity: 1, x: 0}}
                viewport={{once: true}}
                onClick={() => returnToInitial()}>
                <SectionHeader title={<Trans>RESERVE</Trans>}/>
                <InformationWrapper>
                    <Information><Trans>Sending Message</Trans></Information>
                    <Icon spin="true" spinPulse="true" size="lg" icon={faSpinner}/>
                </InformationWrapper>
            </Wrapper>
        )
    }
}

export default Reservation;
